<!-- 企微聊天记录卡片 -->
<template>
  <div class="enterprise-wechat-record" @click="openModal">
    <div class="title">{{ props.msg.title }}</div>
    <PreviewEllipsis :list="previewList || []" />
    <div class="footer" @click.stop="openModal">聊天记录</div>
  </div>

  <RecordDetailModal v-model:visible="modalVisible" :record-data="recordData" />
</template>

<script setup>
import { computed, ref, defineProps } from 'vue'
import RecordDetailModal from './RecordDetailModal.vue'
import PreviewEllipsis from './PreviewEllipsis.vue'
import { parseRecordData } from './utils'
import { mockData } from '@/views/WorkPlace/Container/chat/components/EnterpriseWeChatRecord/mock'

const props = defineProps({
  msg: {
    type: Object,
    default: () => ({})
  }
})

const modalVisible = ref(false)

const recordData = computed(() => {
  return {
    weComGroupId: props.msg.weComGroupId,
    startSeq: props.msg.startSeq,
    endSeq: props.msg.endSeq,
    title: props.msg.title
  }
})

const previewList = computed(() => {
  return JSON.parse(props.msg.chatRecordItemList)
})

const openModal = () => {
  modalVisible.value = true
}
</script>

<style scoped lang="scss">
.enterprise-wechat-record {
  width: 100%;
  background: #ffffff;
  border-radius: 0 8px 8px 8px;
  overflow: hidden;
  cursor: pointer;

  .title {
    padding: 12px 16px 0;
    font-weight: 500;
    font-size: 16px;
    line-height: 25px;
    color: #1a1a1a;
    word-break: break-all;
  }

  .footer {
    padding: 6px 16px;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.04em;
    color: #999999;
    //text-align: center;
    cursor: pointer;
  }
}
</style>
